// Maiusculo automatico em todo campo de texto do sistema (pedido 31/10/2026).
// Um listener so, no document e na fase de captura: roda ANTES do React (que escuta
// na raiz #root), troca o valor do campo e o onChange do React / react-hook-form ja
// recebe o texto em maiusculo - grava assim no banco, nao e so aparencia.
// Ficam de fora: e-mail, senha, campos marcados com data-sem-maiusculo (ou dentro de
// um elemento marcado) e tudo que nao e texto (number, date, select...).

const SEM_MAIUSCULO = /e-?mail|senha|password|url|link|token/i

function deveConverter(el: EventTarget | null): el is HTMLInputElement | HTMLTextAreaElement {
  if (el instanceof HTMLTextAreaElement) {
    // segue
  } else if (el instanceof HTMLInputElement) {
    if (el.type !== 'text' && el.type !== 'search') return false
  } else {
    return false
  }
  if (el.readOnly || el.closest('[data-sem-maiusculo]')) return false
  const pistas = [el.name, el.id, el.getAttribute('autocomplete'), el.getAttribute('inputmode'), el.placeholder].join(' ')
  return !SEM_MAIUSCULO.test(pistas)
}

function converter(el: HTMLInputElement | HTMLTextAreaElement) {
  const atual = el.value
  const novo = atual.toLocaleUpperCase('pt-BR')
  if (novo === atual) return
  const ini = el.selectionStart
  const fim = el.selectionEnd
  // setter nativo do prototipo: o "value tracker" do React continua com o valor antigo,
  // entao ele enxerga a mudanca e dispara o onChange com o texto novo
  const proto = el instanceof HTMLTextAreaElement ? HTMLTextAreaElement.prototype : HTMLInputElement.prototype
  Object.getOwnPropertyDescriptor(proto, 'value')!.set!.call(el, novo)
  if (ini !== null && fim !== null && novo.length === atual.length) el.setSelectionRange(ini, fim)
}

export function ativarMaiusculoAutomatico() {
  document.addEventListener('input', (e) => {
    // acento composto (teclado/IME) - converte no compositionend
    if ((e as InputEvent).isComposing) return
    if (deveConverter(e.target)) converter(e.target)
  }, true)
  document.addEventListener('compositionend', (e) => {
    if (!deveConverter(e.target)) return
    const el = e.target
    converter(el)
    el.dispatchEvent(new Event('input', { bubbles: true }))
  }, true)
}
